import { Button } from "@/components/common/Button";
import Skeleton from "@/components/common/Skeleton";
import { useAirdropValueStore } from "@/modules/airdrop/store/value";
import { useUserStore } from "@/modules/auth/store/user";
import { formatNumber } from "@/modules/auth/utils/format";
import { AnalyticsEvents } from "@/shared/utils/analytics/events";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";

const AirdropBASE = () => {
  const { t } = useTranslation();
  const { airdropBASE: airdrop, isAirdropBASELoading: isAirdropLoading } =
    useUserStore();
  const location = useLocation();

  const navigate = useNavigate();

  const { setNet } = useAirdropValueStore();

  const goToAirdrop = async () => {
    setNet("base");

    await navigate("/airdrop");
  };

  const disabled = Boolean(
    isAirdropLoading ||
      airdrop.token <= 0 ||
      (airdrop.minWithdraw && airdrop.token < airdrop.minWithdraw)
  );

  const analyticsEvent = location.pathname.startsWith("/network")
    ? AnalyticsEvents.Network.ClaimAirdrop
    : AnalyticsEvents.MainPage.ClaimAirdrop;

  return (
    <>
      <div className="flex flex-col bg-bg rounded-[0.75rem]">
        <div className="flex items-center justify-between px-4">
          <div className="flex-1 flex flex-col items-start gap-0.5 py-3">
            <div className="flex items-end gap-1">
              {isAirdropLoading ? (
                <Skeleton className="w-8 h-7" />
              ) : (
                <p className="text-[1.5rem] leading-[1.75rem] font-semibold text-text">
                  {formatNumber(airdrop.token)}
                </p>
              )}
              <p className="text-[1.0625rem] leading-[1.375rem] text-hint pb-px">
                BTN
              </p>
            </div>

            <p className="text-[0.9375rem] leading-[1.25rem] text-subtitle-text">
              {t("main-page.airdrop_balance")} BASE
            </p>
          </div>

          {isAirdropLoading ? (
            <Skeleton className="w-10 h-5.5" />
          ) : (
            <p className="text-[1.0625rem] leading-[1.375rem] text-text">
              ${formatNumber(airdrop.usd)}
            </p>
          )}
        </div>

        <div className="flex flex-col gap-1 w-full p-4 pt-2">
          <Button
            onClick={goToAirdrop}
            text={t("main-page.claim_airdrop")}
            icon="leave"
            mode="bezeled"
            className="w-full"
            disabled={disabled}
            analyticsEvent={analyticsEvent}
          />
          {isAirdropLoading ? (
            <Skeleton className="w-20 h-4 mt-2" />
          ) : (
            <p className="pt-2 text-[0.8125rem] leading-[1rem] text-section-header-text">
              {t("main-page.withdraw.min", {
                amount: airdrop.minWithdraw,
                token: "BTN",
              })}
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default AirdropBASE;
